import type { FeatureType } from '@conversed/shared/src/central/types/feature-access.type';
import {
  getActivePackages,
  getFeatureDefinition,
  hasFeatureAccess,
} from '@conversed/shared/src/utils/feature-access.utils';
import { useMemo } from 'react';
import { useCompanySelector } from './useCompanySelector';

export const useFeatureAccess = () => {
  const { selectedCompany } = useCompanySelector();

  const checkFeatureAccess = useMemo(() => {
    return (feature: FeatureType): boolean => {
      if (!selectedCompany?.packages) {
        return false;
      }

      return hasFeatureAccess(selectedCompany.packages, feature);
    };
  }, [selectedCompany]);

  const activePackages = useMemo(() => {
    if (!selectedCompany?.packages) {
      return [];
    }

    return getActivePackages(selectedCompany.packages);
  }, [selectedCompany]);

  return {
    hasFeatureAccess: checkFeatureAccess,
    getFeatureDefinition,
    activePackages,
    selectedCompany,
  };
};
